
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Confirm from "../core/Confirm";
import UserUtils from '../utils/UserUtils';
import MessageService from '../../service/MessageService';
import { ToastsStore } from 'react-toasts';
import clsx from 'clsx';
import { useHistory } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';

export default connect()(ContactUs);

function ContactUs(props) {
	let history = useHistory();
	const { t } = useTranslation('common');
	const [infoContactUs, setInfoContactUs] = useState({});
	const [errors, setErrors] = useState([]);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		setOpen(props.open);
	}, [props.open]);
	useEffect(() => {
		// Mise a jour du menu
		props.dispatch({ type: 'MENU', menuActive: 'contactUs' })
		setInfoContactUs({
			uidSender: UserUtils.getUser().uid
		})
	}, []);

	/**
	 * Envoi du message Contactez-nous.
	 */
	const send = () => {
		// Formattage pour conserver les retours lignes
		infoContactUs['content'] = infoContactUs.content ? infoContactUs.content.replace(new RegExp('\r?\n', 'g'), '<br />') : '';
		props.dispatch({ type: "SHOW_LOADER" });
		// Envoi du message
		MessageService.contactUs(infoContactUs).then(res => {
			if (res && res.data) {
				ToastsStore.success(t('CNT_IMA_006'));
				history.push('/');
			} else {
				ToastsStore.error(t('CNT_IMA_007'));
			}
			props.dispatch({ type: "HIDE_LOADER" });
			props.dispatch({ type: "HIDE_CONTACT" });
		}).catch(error => {
			ToastsStore.error(t('CNT_IMA_007'));
			props.dispatch({ type: "HIDE_LOADER" });
		});
	}

	/**
	 * Validation avant envoi d'un message Contactez-nous. L'objet et le contenu sont obligatoires.
	 */
	const validate = () => {
		let errors = [];
		if (!infoContactUs.object) {
			errors.push('object')
		}
		if (!infoContactUs.content) {
			errors.push('content');
		}
		setErrors(errors);

		return errors.length === 0;
	}

	/**
	 * Mise à jour des informations de contact lorsque l'objet ou le contenu change.
	 */
	const updateInfoContactUs = (value, attr) => {
		let copy = { ...infoContactUs };
		copy[attr] = value;
		setInfoContactUs(copy);
	}

	/**
	 * Fermer la popup
	 */
	const close = () => {
		setInfoContactUs({});
		props.dispatch({ type: "HIDE_CONTACT" });
	}

	return (
		<>
			<div className={clsx("contact", { "open": open })}>
				<div className="container">
					<div className="titleContainer">
						<span>{t('CNT_IMA_001')}</span>
						<Confirm title={t('')} description={t('CNT_IMA_010')}>
							{confirm => (
								<CloseIcon onClick={confirm(close)} />
							)}
						</Confirm>
					</div>
					<div className="contact-form">
						<div className="information">{t('CNT_IMA_008')}</div>
						<input placeholder={t('CNT_IMA_002')} className={clsx("contact-object", { "error": errors.includes('object') })} maxLength="255" value={infoContactUs.object ? infoContactUs.object : ''} onChange={(e) => updateInfoContactUs(e.target.value, 'object')} />
						<textarea className={clsx({ "error": errors.includes('content') })} type="textarea" maxLength="3000" value={infoContactUs.content ? infoContactUs.content : ''} placeholder={t('CNT_IMA_003')} rows="7" onChange={(e) => updateInfoContactUs(e.target.value, 'content')}></textarea>
						<div className="contactActions">
							<Confirm title={t('')} description={t('CNT_IMA_010')}>
								{confirm => (
									<span className="action cancel" onClick={confirm(close)}>{t('CNT_IMA_009')}</span>
								)}
							</Confirm>
							<Confirm id="gtm-contactus" title={t('')} description={t('CNT_IMA_004')} validate={validate}>
								{confirm => (
									<span className="action" onClick={confirm(send)}>{t('CNT_IMA_005')}</span>
								)}
							</Confirm>
						</div>
					</div>
				</div>
			</div>
			<div className={clsx("background", { "open": open })} />
		</>
	);
}